export default class AgendamentoEnvioMensagemModel {
  constructor({
    id = 0,
    nome = '',
    descricao = null,
    dataHoraEnvio = null,
    canalId = 0,
    gruposContatosIds = [],
    mensagem = null,
    templateEmailId = null,
    templateWhatsAppId = null,
    tituloEmail = null,
    tituloSMS = null,
    conteudoHtmlCustomizado = null,
    statusId = 0,
  } = {}) {
    this.id = id
    this.nome = nome
    this.descricao = descricao
    this.dataHoraEnvio = dataHoraEnvio
    this.canalId = canalId
    this.gruposContatosIds = gruposContatosIds
    this.mensagem = mensagem
    this.templateEmailId = templateEmailId
    this.templateWhatsAppId = templateWhatsAppId
    this.tituloEmail = tituloEmail
    this.tituloSMS = tituloSMS
    this.conteudoHtmlCustomizado = conteudoHtmlCustomizado
    this.statusId = statusId
  }
}
